import { Container, Row, Col } from "react-bootstrap";
import { ArrowRightCircle } from "react-bootstrap-icons";
import { useState, useEffect } from "react";
import headerImg from "../assets/img/Fun_floating_robot.png";
import { scrollToSection } from "../utils/scrollConfig";
import "./Banner.css";

const toRotate = [
  "am your robotics and AI expert",
  "love rapid prototyping",
  "love testing new ideas",
  "am a project leader",
  "am a software engineer",
  "am an electrical engineer",
  "am a robotics engineer",
  "am an AI engineer",
  "am an excellent debugger",
  "am a web developer",
  "am a lifelong learner",
  "was a robotics researcher",
  "am addicted to hobby projects",
  "am an AI enthusiast",
  "am used to agentic software coding",
];

const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(170 - Math.random() * 100);
  const period = 2000;

  useEffect(() => {
    const tick = () => {
      let i = loopNum % toRotate.length;
      let fullText = toRotate[i];
      let updateText = isDeleting
        ? fullText.substring(0, text.length - 1)
        : fullText.substring(0, text.length + 1);

      setText(updateText);

      if (isDeleting) {
        setDelta(30);
      }

      if (!isDeleting && updateText === fullText) {
        setIsDeleting(true);
        setDelta(period);
      } else if (isDeleting && updateText === "") {
        setIsDeleting(false);
        setLoopNum(loopNum + 1);
        setDelta(100);
      }
    };

    let ticker = setInterval(() => {
      tick();
    }, delta);

    return () => {
      clearInterval(ticker);
    };
  }, [delta, loopNum, isDeleting, text, period]); // toRotate is a constant, not a dependency

  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={8} xl={7}>
            <span className="tagline">
              {" "}
              <span className="text-content-large">
                Welcome to Vandeputte-Software-Development
              </span>{" "}
              <span className="text-content-small">
                Welcome to <br /> Vandeputte-Software-Development
              </span>{" "}
            </span>
            <h1>My name is Henri Vandeputte,</h1>
            <p className="banner-subtitle">
              {"I "}
              <span className="txt-rotate">
                <span className="wrap">{text}</span>
              </span>
              {"."}
            </p>
            <p> Get to know me by reading through this website! </p>
            <button
              type="button"
              className="connect-button"
              onClick={() => scrollToSection("connect")}
            >
              {" "}
              Let's Connect <ArrowRightCircle size={35} />
            </button>
          </Col>
          <Col xs={8} md={4} xl={5} className="image-col">
            <img src={headerImg} alt="Henri Vandeputte — robotics and AI engineer" className="img-fluid" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Banner;
